import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { HOW_IT_WORKS_ITEMS } from './constants';
import Card from './Card';

type HowItWorksProps = {};

const HowItWorks: React.FC<HowItWorksProps> = () => {
  return (
    <Box
      id='how-it-works'
      display='flex'
      flexDirection='column'
      gap={{
        sm: 10,
        md: 5,
      }}
      my={10}
    >
      <Typography
        fontSize={{
          xs: '30px',
          sm: '40px',
          md: '57px',
        }}
        fontWeight={600}
        lineHeight='38px'
        mb={{
          xs: 3,
        }}
      >
        How it works
      </Typography>
      <Box display='flex' flexDirection='column' gap={3}>
        {HOW_IT_WORKS_ITEMS.map((item, idx) => (
          <Card key={idx} index={idx} item={item} />
        ))}
      </Box>
    </Box>
  );
};

export default HowItWorks;
